export { init, withSentryConfig } from './client/index.js';
export { captureUnderscoreErrorException } from './common/_error.js';
export { browserTracingIntegration } from './client/browserTracingIntegration.js';
export { wrapGetStaticPropsWithSentry } from './common/wrapGetStaticPropsWithSentry.js';
export { wrapGetInitialPropsWithSentry } from './common/wrapGetInitialPropsWithSentry.js';
export { wrapAppGetInitialPropsWithSentry } from './common/wrapAppGetInitialPropsWithSentry.js';
export { wrapDocumentGetInitialPropsWithSentry } from './common/wrapDocumentGetInitialPropsWithSentry.js';
export { wrapErrorGetInitialPropsWithSentry } from './common/wrapErrorGetInitialPropsWithSentry.js';
export { wrapGetServerSidePropsWithSentry } from './common/wrapGetServerSidePropsWithSentry.js';
export { wrapServerComponentWithSentry } from './common/wrapServerComponentWithSentry.js';
export { wrapRouteHandlerWithSentry } from './common/wrapRouteHandlerWithSentry.js';
export { wrapApiHandlerWithSentryVercelCrons } from './common/wrapApiHandlerWithSentryVercelCrons.js';
export { wrapMiddlewareWithSentry } from './common/wrapMiddlewareWithSentry.js';
export { wrapPageComponentWithSentry } from './common/wrapPageComponentWithSentry.js';
export { wrapGenerationFunctionWithSentry } from './common/wrapGenerationFunctionWithSentry.js';
export { withServerActionInstrumentation } from './common/withServerActionInstrumentation.js';
export * from '@sentry/react';
//# sourceMappingURL=index.client.js.map
